<template>
  <div class="d-inline-block">
    <v-btn
      flat
      icon
      color="white"
      @click="copyUrl">
      <fa-icon
        :icon="['far', 'copy']"
        fixed-width
        size="lg"
        style="color: #919191"/>
    </v-btn>

    <v-tooltip
      v-model="copied"
      z-index="99"
      bottom>
      <div slot="activator" />
      <span>link copied!</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    copyUrl() {
      // copy current url
      this.$copyText(window.location.href).then(() => {
        // show tooltip
        this.copied = true;

        // hide tooltip
        setTimeout(() => {
          this.copied = false;
        }, 800);
      });
    },
  },
};
</script>
